import { render, staticRenderFns } from "./CustomerContactTypes.vue?vue&type=template&id=923c8d72&"
import script from "./CustomerContactTypes.vue?vue&type=script&lang=js&"
export * from "./CustomerContactTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports